import * as React from "react";
import {
  Configure,
  connectStateResults,
  Hits,
  Index,
} from "react-instantsearch-dom";
import { indexName } from "../index_name";
import { IndexProps } from "../index_props";
import { SearchIndex } from "../types";

type CategoryHitProps = {
  hit: SearchIndex.Category;
};

const CategoryHit = ({ hit: category }: CategoryHitProps): JSX.Element => (
  <a href={category.link_path}>
    <div className={"image-container"}>
      <img src={category.search_image_url} alt={category.name_singular} />
    </div>
    {category.name_plural}
  </a>
);

const CategoryResults = connectStateResults(
  ({ searchResults }): JSX.Element | null => {
    if (searchResults?.nbHits == 0) return null;

    return (
      <>
        <h4>Kategorie</h4>
        <Configure hitsPerPage={2} />
        <Hits hitComponent={CategoryHit} />
      </>
    );
  }
);

export const CategoryIndex = ({ environment }: IndexProps): JSX.Element => (
  <Index indexName={indexName(environment, "Sporilek_Category")}>
    <CategoryResults />
  </Index>
);
